import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import router from "@/router";
  import {
    InitialHoldInterface,
    InitialHoldWithLotInterface,
  } from "@/types/InitialHoldInterface";
  import store from "@/store";
  import { formatDate } from "@/helpers/date";
  import { getInitialHoldStatusClass } from "@/helpers/status";
  import { useToast } from "vue-toastification";
  import { getInitialHoldStatusText } from "@/helpers/initialHold/getInitialHoldStatusText";
  import { isLotOwner } from "@/helpers/lot/isLotOwner";
  import { LotInterface } from "@/types/LotInterface";
  import { Business } from "@/types/BusinessInterface";
  import { AxiosResponse } from "axios";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotInitialHold',
  props: {
    lot: {
      type: Object,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;
  const toast = useToast();

  const initialHolds = ref<InitialHoldInterface[] | null>(null);
  const estateId = computed(() => store.state.user.selectedEstateId);
  const lotId = router.currentRoute.value.params.lotId;
  const userBusiness = ref<Business | null>(null);
  const estate = computed(() =>
    store.state.user.landownerEstates.find((e) => e._id === estateId.value)
  );
  const canManageLot = computed(() =>
    isLotOwner(props.lot as LotInterface, userBusiness.value, estate.value)
  );

  const tableHeaders = computed(() => {
    const headers = [
      "Name",
      "Email",
      "Phone",
      "Company",
      "Status",
      "Created",
      "Expiry",
    ];

    if (!canManageLot.value) {
      return headers;
    }

    return [...headers, ""];
  });
  const getExpirationDate = (date: string) => {
    if (!date) {
      return "-";
    }

    return formatDate(date);
  };

  const getFullName = ({ leadsDetails }: InitialHoldInterface) => {
    const { firstName, lastName } = leadsDetails;

    return `${firstName} ${lastName}`;
  };

  const getInitialHolds = async () => {
    try {
      const { data } = await store.dispatch(
        "initialHold/getInitialHolds",
        estateId.value
      );
      const initialHoldsWithLot = data.find(
        (item: InitialHoldWithLotInterface) => item._id === lotId
      );

      if (!initialHoldsWithLot) {
        return;
      }

      initialHolds.value = orderByCreatedAt(initialHoldsWithLot.initialHold);
    } catch (error) {
      toast.error("Something went wrong, please try again later.");
    }
  };
  const orderByCreatedAt = (holds: InitialHoldInterface[]) => {
    return holds.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  };
  const onManageInitialHold = (initialHoldId: string) => {
    router.push({
      name: "HoldRequestDetails",
      params: { id: initialHoldId },
    });
  };

  const getUserBusiness = () => {
    store
      .dispatch("business/getBusinessByLandownerId")
      .then((res: AxiosResponse<Business>) => {
        userBusiness.value = res.data;
      });
  };

  onMounted(() => {
    getInitialHolds();
    getUserBusiness();
  });

const __returned__ = { props, toast, initialHolds, estateId, lotId, userBusiness, estate, canManageLot, tableHeaders, getExpirationDate, getFullName, getInitialHolds, orderByCreatedAt, onManageInitialHold, getUserBusiness, computed, onMounted, ref, get router() { return router }, get InitialHoldInterface() { return InitialHoldInterface }, get InitialHoldWithLotInterface() { return InitialHoldWithLotInterface }, get store() { return store }, get formatDate() { return formatDate }, get getInitialHoldStatusClass() { return getInitialHoldStatusClass }, get useToast() { return useToast }, get getInitialHoldStatusText() { return getInitialHoldStatusText }, get isLotOwner() { return isLotOwner }, get LotInterface() { return LotInterface }, get Business() { return Business }, get AxiosResponse() { return AxiosResponse } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})